import type { ImpressionType } from '@/ImpressionType'

export const impressionData5minutes: ImpressionType = {
  title: '5 minutes.',
  impressionContent: `
<p>
5 minutes a tes côtés,<br/>
Sur deux portées,<br/>
Nous jouions nos vies,<br/>
Sur deux octaves,<br/>
Moi, ici, toi ? là-bas,<br/>
Jamais au même endroit.<br/>
<br/>
</p>

<p>
C'est ton silence qui nous réunit,<br/>
Me voilà, soliste,<br/>
Privé de contrepoint ?<br/>
Non... Frappé de douleur.<br/>
Nous étions mélodie,<br/>
Aux mouvements séparés.<br/>
<br/>
</p>

<p>
Et maintenant,<br/>
En silence,<br/>
En souffrance,<br/>
Je prends tes mains,<br/>
Désincarné,<br/>
Que ton âme a quitté,<br/>
Au chevet,<br/>
De ton lit glacé.<br/>
<br/>
</p>

<p>
5 minutes,<br/>
C'est une musique,<br/>
De reproches, de mots,<br/>
De ces silences qui disent trop,<br/>
C'est autant,<br/>
Trémolo, vibrato,<br/>
Une physique des corps<br/>,
D'où jaillissent des mots,<br/>
Sang et sanglot.<br/>
<br/>
</p>

<p>
5 minutes,<br/>
C'est bien peu pour te dire adieu,<br/>
Et bien trop pour te voir comme ça,<br/>
Sans énergie, sans vie, sans tes yeux, sans ta voix.<br/>
Où la pudeur d'un vêtement,<br/>
Masque les marques de tes tourments.<br/>
<br/>
</p>

<p>
Je te serre, t'embrasse,<br/>
Poche ta main dans la mienne,<br/>
Te couve comme je ne l'ai jamais fait.<br/>
Il m'aura fallut attendre,<br/>
Ton silence, ton décès.<br/>
<br/>
</p>

<p>
Le temps était compté.<br/>
</p>
 `,
  illustrationCaption: 'Un peu de distance...',
  illustrationCopyright: 'Source: openai',
  illustrationPath: '/img/impressions/5-minutes-2.jpg',
  noteEntries: [
    'Un an après..'
  ]
}
